import { UseMutateFunction } from '@tanstack/react-query';
import { useForm, SubmitHandler } from 'react-hook-form';
import { Button } from 'antd';

import { InputsForgotPassword } from 'types';

import { Input } from '../common/input';
import useTranslation from '../../customHooks/translate';
import { useNavigate } from 'react-router-dom';

interface IProps {
  isLoading: boolean;
  passwordResetHandler: UseMutateFunction<any, unknown, any>;
  emailError?: string | null;
}

const ForgotPasswordForm = ({
  passwordResetHandler,
  emailError,
  isLoading,
}: IProps) => {
  const { register, handleSubmit, formState } = useForm<InputsForgotPassword>(
    {}
  );
  const translation = useTranslation();
  const navigate = useNavigate();

  const handleRedirectRegister = () => {
    navigate('/login');
  };

  const { errors } = formState;

  const onSubmit: SubmitHandler<InputsForgotPassword> = (data) =>
    passwordResetHandler(data);

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="flex flex-col gap-[24px]"
    >
      <div className="flex flex-col gap-[8px]">
        <Input
          id="email"
          label={`${translation.forgotPassword.Mail}`}
          placeholder="example-mail@domain.com"
          error={errors.email}
          autoComplete="email"
          {...register('email', { required: translation.login.requiredField })}
          style={{
            borderColor: errors.email || emailError ? 'red' : '',
          }}
        />

        {errors.email && (
          <span
            className="animate__animated animate__shakeX"
            style={{
              color: 'red',
              fontSize: '12px',
              textTransform: 'capitalize',
            }}
          >
            {errors.email.message}
          </span>
        )}
        {emailError && (
          <span
            className="animate__animated animate__shakeX"
            style={{
              color: 'red',
              fontSize: '12px',
              textTransform: 'capitalize',
            }}
          >
            {emailError}
          </span>
        )}
      </div>
      <Button
        htmlType="submit"
        className="h-[44px] rounded-md !border-0 !bg-[#6DCE92] font-medium !text-white shadow-none transition-colors duration-200 hover:!border-0 hover:!bg-[#5EC082] hover:!text-white focus:!border-0 focus:!bg-[#6DCE92] focus:!text-white active:!border-0 active:!bg-[#5EC082] active:!text-white"
        loading={isLoading}
      >
        {translation.forgotPassword.LinkButton}
      </Button>
      <Button
        onClick={handleRedirectRegister}
        className="h-[44px] rounded-md !border !border-[#6DCE92] !bg-white font-medium !text-[#6DCE92] shadow-none transition-colors duration-200 hover:!border-[#6DCE92] hover:!bg-[#F3F4F6] hover:!text-[#6DCE92] focus:!border-[#6DCE92] focus:!bg-white focus:!text-[#6DCE92] active:!border-[#6DCE92] active:!bg-[#F3F4F6] active:!text-[#6DCE92]"
      >
        {translation.forgotPassword.LoginButton}
      </Button>
    </form>
  );
};

export default ForgotPasswordForm;
